import React from 'react';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Горизонтальный разделитель между секциями в футере
 */
export var FooterDivider = function FooterDivider(_ref) {
  var _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? '40px 0' : _ref$margin,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#c9d1e5' : _ref$color;
  return /*#__PURE__*/_jsx("hr", {
    className: styles['divider'],
    style: {
      margin: margin,
      backgroundColor: color
    }
  });
};